import { Link } from 'react-router-dom';
import { getTrendingArticles } from '@/mocks/articles';
import { hotTags } from '@/mocks/categories';

export default function TrendingSection() {
  const trending = getTrendingArticles().slice(0, 6);

  return (
    <aside className="space-y-6">
      <div className="bg-background-50 rounded-xl border border-background-200/70 p-5">
        <div className="flex items-center gap-2 mb-4">
          <i className="ri-fire-line w-5 h-5 flex items-center justify-center text-accent-500"></i>
          <h3 className="font-heading text-base text-foreground-950">热门排行</h3>
        </div>
        <div className="space-y-3">
          {trending.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="flex items-start gap-3 group cursor-pointer"
            >
              <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${
                index < 3 ? 'bg-primary-500 text-white' : 'bg-background-100 text-foreground-500'
              }`}>
                {index + 1}
              </span>
              <div className="min-w-0">
                <p className="text-sm text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </p>
                <span className="text-xs text-foreground-500 mt-1 block">{article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万阅读` : `${article.views}阅读`}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="bg-background-50 rounded-xl border border-background-200/70 p-5">
        <div className="flex items-center gap-2 mb-4">
          <i className="ri-hashtag w-5 h-5 flex items-center justify-center text-secondary-600"></i>
          <h3 className="font-heading text-base text-foreground-950">热门标签</h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <a
              key={tag}
              href={`#tag-${tag}`}
              className="text-xs bg-secondary-100 text-secondary-700 hover:bg-secondary-200 px-3 py-1.5 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {tag}
            </a>
          ))}
        </div>
      </div>

      <div className="bg-accent-500 rounded-xl p-5 text-white">
        <h3 className="font-heading text-base mb-2">📢 投稿爆料</h3>
        <p className="text-sm text-white/80 leading-relaxed mb-3">
          你有独家爆料？欢迎向我们投稿！我们保护每一位爆料者的隐私安全。
        </p>
        <a
          href="mailto:tougao@heiliaochigua.com"
          className="inline-block text-sm bg-white text-accent-600 px-4 py-2 rounded-lg font-medium hover:bg-white/90 transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          立即投稿
        </a>
      </div>
    </aside>
  );
}